import debugFactory from "debug"

export const debugLog = debugFactory("eosq")

